export default {"src":"/encomendas-static/_next/static/media/step-calc.448cb228.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};